import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutPrincipalComponent } from './layout/layout-principal/layout-principal.component';
import { Path } from './util/path';
import {MuralDigitalComponent} from './mural-digital/mural-digital.component';


const routes: Routes = [
  {
    path: 'mural-digital',
    component: MuralDigitalComponent,
  },
  {
    path: '',
    component: LayoutPrincipalComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./paginas/pagina-principal/pagina-principal.module').then(m => m.PaginaPrincipalModule)
      },
      {
        path: Path.INSTITUCIONAL.caminho,
        loadChildren: () => import('./paginas/institucional/institucional.module').then(m => m.InstitucionalModule)
      },
      {
        path: Path.ADMINISTRACAO.caminho,
        loadChildren: () => import('./paginas/administracao/administracao.module').then(m => m.AdministracaoModule)
      },
      {
        path: Path.ADMINISTRACAOESTAGIO.caminho,
        loadChildren: () => import(
          './paginas/administracao/selecoes-concursos/estagiarios/estagiarios.module').then(m => m.EstagiariosModule)
      },
      {
        path: Path.PROCESSOS_FISICOS.caminho,
        loadChildren: () => import('./paginas/processos-fisicos/processos-fisicos.module').then(m => m.ProcessosFisicosModule)
      },
      {
        path: Path.TRANSPARENCIA.caminho,
        loadChildren: () => import('./paginas/transparencia/transparencia.module').then(m => m.TransparenciaModule)
      },
      {
        path: Path.JUIZADOS_ESPECIAIS.caminho,
        loadChildren: () => import('./paginas/juizados-especiais/juizados-especiais.module').then(m => m.JuizadosEspeciaisModule)
      },
      {
        path: Path.PAGINAS_SETORIAIS.caminho,
        loadChildren: () => import('./paginas/paginas-setoriais/paginas-setoriais.module').then(m => m.PaginasSetoriaisModule)
      },
      {
        path: Path.CANAIS_ATENDIMENTO.caminho,
        loadChildren: () => import('./paginas/canais-atendimento/canais-atendimento.module').then(m => m.CanaisAtendimentoModule)
      },
      {
        path: Path.CARTA_SERVICOS.caminho,
        loadChildren: () => import('./paginas/carta-de-servicos/carta-de-servicos.module').then(m => m.CartaDeServicosModule)
      },
      {
        path: Path.PJE.caminho,
        loadChildren: () => import('./paginas/pje/pje.module').then(m => m.PjeModule)
      },
      {
        path: Path.SIC_OUVIDORIA.caminho,
        loadChildren: () => import('./paginas/fale/fale-conosco.module').then(m => m.FaleConoscoModule)
      },
      {
        path: Path.IMPRENSA.caminho,
        loadChildren: () => import('./paginas/imprensa/imprensa.module').then(m => m.ImprensaModule)
      },
      {
        path: Path.AVISO.caminho,
        loadChildren: () => import('./paginas/aviso/aviso.module').then(m => m.AvisoModule)
      },
      {
        path: Path.PLANTAO.caminho,
        loadChildren: () => import('./paginas/plantao-judiciario/plantao-judiciario.module').then(m => m.PlantaoJudiciarioModule)
      },
      {
        path: Path.CENTRO_ESPECIALIZADO_DE_ACOLHIMENTO_A_VITIMA.caminho,
        loadChildren: () => import('./paginas/ceav/ceav.module').then(m => m.CeavModule)
      },
      {
        path: Path.COMISSAO_ACESSIBILIDADE.caminho,
        loadChildren: () => import('./paginas/comissao-acessibilidade/comissao-acessibilidade.module').then(m => m.ComissaoAcessibilidadeModule)
      },
      {
        path: Path.PAINEL_ESTAGIO.caminho,
        loadChildren: () => import('./paginas/painel-estagio/painel-estagio.module').then(m => m.PainelEstagioModule)
      },
      {
        path: Path.CURADORIA_QUINTA_JURIDICA.caminho,
        loadChildren: () => import(
          './paginas/curadoria-quinta-juridica/curadoria-quinta-juridica.module').then(m => m.CuradoriaQuintaJuridicaModule)
      },
      {
        path: Path.QUINTA_JURIDICA.caminho,
        children: [
          {
            path: '',
            loadChildren: () => import('./paginas/curadoria-quinta-juridica/curadoria-quinta-juridica.module').then(m => m.CuradoriaQuintaJuridicaModule)
          },
          {
            path: Path.QUINTA_JURIDICA_CERTIFICADO.caminho,
            loadChildren: () => import('./paginas/quinta-juridica/certificado/certificado.module').then(m => m.CertificadoModule)
          }
        ]
      },
      {
        path: Path.JFRN_SUSTENTAVEL.caminho,
        loadChildren: () => import('./paginas/jfrn-sustentavel/jfrn-sustentavel.module').then(m => m.JFSustentavelModule)
      },
      {
        path: Path.COOPERACAO.caminho,
        loadChildren: () => import('./paginas/cooperacao-judiciaria/cooperacao-judiciaria.module').then(m => m.CooperacaoJudiciariaModule)
      },
      {
        path: Path.AJG.caminho,
        loadChildren: () => import('./paginas/ajg/ajg.module').then(m => m.AJGModule)
      },
      {
        path: Path.JUD_SAUDE.caminho,
        loadChildren: () => import('./paginas/jud-saude/jud-saude.module').then(m => m.JudSaudeModule)
      },
      {
        path: Path.CUSTAS_PROCESSUAIS.caminho,
        loadChildren: () => import('./paginas/custas-processuais/custas-processuais.module').then(m => m.CustasProcessuaisModule)
      },
      {
        path: Path.BUSCA.caminho,
        loadChildren: () => import('./paginas/busca/busca.module').then(m => m.BuscaModule)
      },
      {
        path: Path.VIDEOS_INSTITUCIONAIS_EDUCATIVOS.caminho,
        loadChildren: () => import(
          './paginas/imprensa/videos-institucionais-educativos/videos-institucionais-educativos.module').then(
            m => m.VideosInstitucionaisEducativosModule)
      },
      {
        path: Path.VIDEOS_COM_AUDIODESCRICAO.caminho,
        loadChildren: () => import(
          './paginas/imprensa/videos-com-audiodescricao/videos-com-audiodescricao.module').then(m => m.VideosComAudiodescricaoModule)
      },
      {
        path: Path.REDES_SOCIAIS.caminho,
        loadChildren: () => import('./paginas/imprensa/redes-sociais/redes-sociais.module').then(m => m.RedesSociaisModule)
      },

      {
        path: Path.COMISSAO_ASSEDIO.caminho,
        loadChildren: () => import('./paginas/comissao-assedio/comissao-assedio.module').then(m => m.ComissaoAssedioModule)
      },
      {
        path: Path.COMISSAO_CPAMAS.caminho,
        loadChildren: () => import('./paginas/comissao-dinamica/comissao-dinamica.module').then(m => m.ComissaoDinamicaModule)
      },
      {
        path: Path.COMISSAO_TOPICOS.caminho,
        loadChildren: () => import('./paginas/comissao-topicos/comissao-topicos.module').then(m => m.ComissaoTopicosModule)
      },
      {
        path: Path.COMISSAO_SOBRE_NOS.caminho,
        loadChildren: () => import('./paginas/comissao-sobre-nos/comissao-sobre-nos.module').then(m => m.ComissaoSobreNosModule)
      },
      {
        path: Path.CEJURE_JUSTICA_RESTAURATIVA.caminho,
        loadChildren: () => import(
          './paginas/cejure-justica-restaurativa/cejure-justica-restaurativa.module').then(m => m.CejureJusticaRestaurativaModule)
      },
      {
        path: Path.COMISSAO_GAMS.caminho,
        loadChildren: () => import('./paginas/comissao-gams/comissao-gams.module').then(m => m.ComissaoGamsModule)
      },
      {
        path: Path.VIDEOS_INSTITUCIONAIS_EDUCATIVOS.caminho,
        loadChildren: () => import('./paginas/imprensa/videos-institucionais-educativos/videos-institucionais-educativos.module').then(m => m.VideosInstitucionaisEducativosModule)
      },
      {
        path: Path.VIDEOS_COM_AUDIODESCRICAO.caminho,
        loadChildren: () => import('./paginas/imprensa/videos-com-audiodescricao/videos-com-audiodescricao.module').then(m => m.VideosComAudiodescricaoModule)
      },
      {
        path: Path.REDES_SOCIAIS.caminho,
        loadChildren: () => import('./paginas/imprensa/redes-sociais/redes-sociais.module').then(m => m.RedesSociaisModule)
      },

      {
        path: Path.COMISSAO_ASSEDIO.caminho,
        loadChildren: () => import('./paginas/comissao-assedio/comissao-assedio.module').then(m => m.ComissaoAssedioModule)
      },
      {
        path: Path.COMISSAO_CPAMAS.caminho,
        loadChildren: () => import('./paginas/comissao-dinamica/comissao-dinamica.module').then(m => m.ComissaoDinamicaModule)
      },
      {
        path: Path.COMISSAO_TOPICOS.caminho,
        loadChildren: () => import('./paginas/comissao-topicos/comissao-topicos.module').then(m => m.ComissaoTopicosModule)
      },
      {
        path: Path.COMISSAO_SOBRE_NOS.caminho,
        loadChildren: () => import('./paginas/comissao-sobre-nos/comissao-sobre-nos.module').then(m => m.ComissaoSobreNosModule)
      },
      {
        path: Path.CEJURE_JUSTICA_RESTAURATIVA.caminho,
        loadChildren: () => import('./paginas/cejure-justica-restaurativa/cejure-justica-restaurativa.module').then(m => m.CejureJusticaRestaurativaModule)
      },
      {
        path: Path.COMISSAO_GAMS.caminho,
        loadChildren: () => import('./paginas/comissao-gams/comissao-gams.module').then(m => m.ComissaoGamsModule)
      },
      {
        path: '**',
        loadChildren: () => import('./paginas/pagina-inexistente/pagina-inexistente.module').then(m => m.PaginaInexistenteModule)
      }
    ]
  }
];

@NgModule({
  imports:
    [RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
